import { render, staticRenderFns } from "./imagen.vue?vue&type=template&id=1334d4d4&scoped=true&"
import script from "./imagen.vue?vue&type=script&lang=js&"
export * from "./imagen.vue?vue&type=script&lang=js&"
import style0 from "./imagen.vue?vue&type=style&index=0&id=1334d4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334d4d4",
  null
  
)

export default component.exports